import CryptoJs from 'crypto-js';

/* eslint-disable */
const a = '2a4ac92b';
const b = '8217a77a';
const c = '44bf0314';
const d = 'c4e1b101';
const key = CryptoJs.enc.Utf8.parse(`${a}${b}`);
const iv = CryptoJs.enc.Utf8.parse(`${c}${d}`);

export function enctypeAes(prama, timestamp) {
  // 成产key
  const KeyStr = CryptoJs.SHA256(timestamp).toString().substring(0, 16);
  const key2 = CryptoJs.enc.Utf8.parse(KeyStr);
  // 生产 iv
  const ivStr = CryptoJs.SHA256(KeyStr + timestamp).toString().substring(0, 16);
  const iv2 = CryptoJs.enc.Utf8.parse(ivStr);
  // 加密
  const encryptResult = CryptoJs.AES.encrypt(JSON.stringify(prama), key2, {
    iv: iv2,
    mode: CryptoJs.mode.CBC,
    padding: CryptoJs.pad.Pkcs7,
  });
  return encryptResult.toString();
}

export function dectyptAES(content) {
  const bytes = CryptoJs.AES.decrypt(content.toString(), key, {
    iv,
    mode: CryptoJs.mode.CBC,
    padding: CryptoJs.pad.Pkcs7,
  });
  return bytes.toString(CryptoJs.enc.Utf8);
}

export function uuid() {
  const s = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i += 1) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  // bits 12-15 of the time_hi_and_version field to 0010
  s[14] = '4';
  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = '-';
  return s.join('');
}

const getDevice = () => {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
  // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if (isAndroid) {
    return 'Android';
  }
  return 'IOS';
};


export function getTimeStamp() {
  return new Date().getTime().toString();
}


export function encryptMd5(prama) {
  return CryptoJs.MD5(prama).toString();
}

export function encryptBase64(prama) {
  const str = CryptoJs.enc.Utf8.parse(prama);
  return CryptoJs.enc.Base64.stringify(str);
}

export function decryptBase64(prama) {
  const str = CryptoJs.enc.Base64.parse(prama);
  return str.toString(CryptoJs.enc.Utf8);
}

export function authorization(currTimeStamp, body, au) {
  const data = {};
  data.os = getDevice();
  data.version = '3.0';
  data.timestamp = currTimeStamp;
  data.access_token = encryptMd5(currTimeStamp).substring(11, 17).toUpperCase();
  data.cm = encryptMd5(body);
  data.au = au;
  return data;
}

export function getReqData(data, timestamp) {
  const aesData = enctypeAes(data, timestamp);
  return encryptBase64(aesData);
}

export function getRepData(data) {
  // Base64 转码
  const deB64data = decryptBase64(data);
  // aes 解密
  const deAesData = dectyptAES(deB64data);
  return JSON.parse(deAesData);
}

// 上传文件 的加密headers
export function uploadHeaders() {
  const data = {};
  const currTimeStamp = `${uuid()}-${getTimeStamp()}`;
  data.os = 'web';
  data.version = '1.7';
  data.timestamp = currTimeStamp;
  data.access_token = encryptMd5(currTimeStamp).substring(11, 17).toUpperCase();
  return data;
}
